/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EmployeeGridListApiModel { 
    id: number;
    titleBeforeName: string;
    name: string;
    surname: string;
    titleAfterName: string;
    dateOfBirth: string;
    personalNumber: string;
    active: boolean;
    hasActiveContract: boolean;
    isOrdered: boolean;
    eligibleTo?: string | null;
    occupations: Array<string>;
}

